import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { validateKeyAndStore } from '../helpers/auth'
import { socket } from '../socket'

export default function Login() {
	const [key, setKey] = useState('')
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	async function handleSubmit(e) {
		e.preventDefault()
		setError('')
		setLoading(true)

		const ok = await validateKeyAndStore(key)

		if (ok) {
			socket.disconnect().connect()
			const redirect = searchParams.get('redirect') || '/dashboard/draft'
			navigate(redirect, { replace: true })
		} else {
			setError('Invalid key. Please try again.')
		}

		setLoading(false)
	}

	return (
		<div className="flex items-center justify-center min-h-screen bg-[#181818]">
			<div className="w-80 rounded-lg border border-gray-700 bg-[#222222] p-8 text-center">
				<form onSubmit={handleSubmit} className="flex flex-col gap-3">
					<input
						className="w-full"
						type="password"
						placeholder="Enter access key"
						value={key}
						onChange={(e) => setKey(e.target.value)}
						autoFocus
						disabled={loading}
					/>
					{error && <p className="text-sm text-red-400">{error}</p>}
					<button type="submit" disabled={loading || !key}>
						{loading ? 'Verifying…' : 'Enter'}
					</button>
				</form>
			</div>
		</div>
	)
}
